




















import { Component, Vue, Ref } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { StageActionsKeys, StageActionsPayload } from '@/store/types/stageState';
import { ClickOutside } from 'vuetify/lib';

@Component({
  directives: {
    ClickOutside,
  },
})
export default class MessageBox extends Vue {
  @Action(StageActionsKeys.SEND_SHOUT) sendShout!: (payload: StageActionsPayload['SEND_SHOUT']) => void;
  @Ref('input') input!: {
    $el: HTMLElement;
    focus: () => void;
    blur: () => void;
  };

  message = '';

  mounted() {
    this.input.$el.addEventListener('paste', this.onPaste);
  }

  beforeDestroy() {
    this.input.$el.removeEventListener('paste', this.onPaste);
  }

  onPaste(e: ClipboardEvent) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.cancelBubble = true;
  }

  onMessage() {
    this.input.focus();
    if (!this.validMessage) return;
    this.sendShout(this.message);
    this.message = '';
  }

  get validMessage() {
    return this.message && this.message.length <= 150;
  }

  clickOutside = {
    handler: () => {
      if (this.$refs.input) (this.$refs.input as HTMLElement).blur();
    },
    closeConditional: (e: MouseEvent) => {
      if (
        e.target &&
        this.$refs.button &&
        ((this.$refs.button as Vue).$el as HTMLElement).contains(e.target as HTMLElement)
      ) {
        return false;
      }
      return true;
    },
  };
}
